module.exports = __webpack_public_path__ + "static/media/logo.6db47982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 109
// module chunks = 3